export default {
  permissions() {
    return this.$auth.user()
  },
  showStockQuantity() {
    return false
  },
  cookie() {
    return '4IWVrqSYW56WmG1pYmdsnG2dXFidntxTaoTQoZvLmZrTzpOalJ2i0oePWqWTpJmGcpdosw=='
  }
}